import { Injectable } from "@angular/core";
import { Observable, catchError, of } from "rxjs";
import { AuditoriaEvento } from "../models/auditoria.model";
import {
	ApiEnum,
	HttpDataService,
} from "./http-data.service";

/**
 * Lectura del historial de cambios (audit trail). El endpoint está gateado en back
 * (admin / Manage / responsable); ante 403 o error se devuelve [] para ocultar la
 * sección sin romper la vista (la pestaña ya se muestra solo a quien puede editar).
 */
@Injectable({ providedIn: "root" })
export class AuditoriaService {
	constructor(private readonly httpDataService: HttpDataService) {}

	getHistorialContrato(contratoId: number): Observable<AuditoriaEvento[]> {
		return this.httpDataService
			.get$<AuditoriaEvento[]>(ApiEnum.API_ROOT, `/Auditoria/Contrato/${contratoId}`)
			.pipe(catchError(() => of<AuditoriaEvento[]>([])));
	}

	getHistorialCentro(centroId: number): Observable<AuditoriaEvento[]> {
		return this.httpDataService
			.get$<AuditoriaEvento[]>(ApiEnum.API_ROOT, `/Auditoria/Centro/${centroId}`)
			.pipe(catchError(() => of<AuditoriaEvento[]>([])));
	}
}
